import script from "./web-app-logout.vue?vue&type=script&setup=true&lang=js"
export * from "./web-app-logout.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__